import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Cookie from 'js-cookie';

// components
import SofologistLogin from './SofologistLogin';
import SofologistCustomerFinder from './SofologistCustomerFinder';

// actions
import { loginSofologistFromJWT, sofologistLogout } from '../../actions/sofologist';

class _AdminPage extends Component {

  constructor(props) {
    super(props);
    const sofologistCookie = Cookie.getJSON('mySofologySofologist');
    if(sofologistCookie && sofologistCookie.token) {
      if(!sofologistCookie.location) {
        sofologistLogout();
      } else {
        props.loginSofologistFromJWT(sofologistCookie);
      }
    }
  }

  render() {
    const { sofologist } = this.props;
    return (
      <div>
        {sofologist.Authorized ? <SofologistCustomerFinder /> : <SofologistLogin />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sofologist: state.sofologist
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loginSofologistFromJWT, sofologistLogout
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(_AdminPage);



// WEBPACK FOOTER //
// ./src/pages/AdminPage/index.js